import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { getRollingLimits } from 'src_server/trpc/types/responsibleGambling';
import {
    CalculationTypeToggleOption,
    CalculationTypeToggleTrack,
} from 'src/domains/players/webview/components/Account/limitsTab/rollingNetDepositLimit/DepositLimitsProcedure.style';

interface DepositLimitsCalculationTogglePropsType {
    value: getRollingLimits.CalculationTypeSchemaType;
    onChange: (value: getRollingLimits.CalculationTypeSchemaType) => void;
    dataTest?: string;
}

export const DepositLimitsCalculationToggle = observer(
    'DepositLimitsCalculationToggle',
    ({ value, onChange, dataTest = 'deposit-limits-calculation-toggle' }: DepositLimitsCalculationTogglePropsType) => {
        return (
            <CalculationTypeToggleTrack
                role='radiogroup'
                data-test={dataTest}
            >
                <CalculationTypeToggleOption
                    type='button'
                    role='radio'
                    aria-checked={value === 'gross'}
                    isSelected={value === 'gross'}
                    onClick={(): void => {
                        onChange('gross');
                    }}
                    data-test={`${dataTest}-gross`}
                >
                    <I18n
                        langKey='account.deposit-limits-edit.type.gross'
                        defaultText='Deposit Limits'
                    />
                </CalculationTypeToggleOption>
                <CalculationTypeToggleOption
                    type='button'
                    role='radio'
                    aria-checked={value === 'net'}
                    isSelected={value === 'net'}
                    onClick={(): void => {
                        onChange('net');
                    }}
                    data-test={`${dataTest}-net`}
                >
                    <I18n
                        langKey='account.deposit-limits-edit.type.net'
                        defaultText='Net Deposit Limits'
                    />
                </CalculationTypeToggleOption>
            </CalculationTypeToggleTrack>
        );
    }
);
